module.exports = __webpack_public_path__ + "static/don44-1516f81a642f2398f8a07cc4f2eab349.jpg";